module.exports = __webpack_public_path__ + "img/square-phone-flip.b9f4afb9.svg";